import "./DashboardStyle.css";
import { useSidebar } from "../../SidebarContext";
import StaffHomeDashboard from "./StaffHomeDashboard";

const Dashboard = () => {
  const { isSidebarOpen } = useSidebar();

  return (
    <div className={`open-close ${isSidebarOpen ? "open" : "closed"}`}>
      <StaffHomeDashboard />
    </div>
  );
};

export default Dashboard;
